import { IconArrowRight, IconFileText } from "@tabler/icons-react";
import type { FC } from "react";

export interface AutomationReportTileProps {
  title: string;
  /** Shown under the title — e.g. the recipient the report was written for. */
  subtitle?: string;
  /** Shows the trailing arrow; set when the caller wraps the tile in a link. */
  isLinked?: boolean;
}

/**
 * A saved report as a tile. Presentational: the caller wraps it in the link to
 * the report page — a run's transcript and the chat's preview-run card both
 * render it this way.
 */
export const AutomationReportTile: FC<AutomationReportTileProps> = (props) => {
  const { title, subtitle, isLinked } = props;
  return (
    <div className="flex items-center gap-3 rounded-lg border border-border-light bg-white p-3 transition-colors hover:border-border-strong">
      <span className="flex size-8 shrink-0 items-center justify-center rounded-md bg-indigo-50 text-indigo-600">
        <IconFileText aria-hidden className="size-4" />
      </span>
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-medium text-foreground">{title}</p>
        {subtitle ? (
          <p className="truncate text-xs text-muted-foreground">{subtitle}</p>
        ) : null}
      </div>
      {isLinked ? (
        <IconArrowRight
          aria-hidden
          className="size-4 shrink-0 text-muted-foreground"
        />
      ) : null}
    </div>
  );
};
